import { render, staticRenderFns } from "./VendorDashboard.vue?vue&type=template&id=2da7da96"
import script from "./VendorDashboard.vue?vue&type=script&lang=ts"
export * from "./VendorDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports